import React from 'react';

function SectionMenu({ targetRef }) {

    const handleScroll = () => {
        targetRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="section-menu md:px-[50px] lg:px-[100px] bg-[#F1F8FF]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="flex items-center justify-start md:justify-end px-5">
                    <div className="flex flex-col">
                        <div>
                            <div className="flex items-center md:items-baseline">
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/media/images/alert-icon.png`} className="w-[40px] md:w-[40px] lg:w-[50px] xl:w-[82px] mr-5" alt="FamilyMart Indonesia" />
                                </div>
                                <div>
                                    <h2 className="text-sky-500 hidden md:flex md:text-3xl lg:text-5xl xl:text-7xl font-extrabold text-end">Flavor<br /> Alert! </h2>
                                    <h2 className="text-sky-500 flex md:hidden text-2xl md:text-3xl lg:text-5xl xl:text-7xl font-extrabold text-end">Flavor Alert! </h2>
                                </div>
                            </div>
                        </div>
                        <div className='hidden md:flex justify-end'>
                            <button onClick={handleScroll}><h4 className="text-sky-500 md:text-xl lg:text-2xl xl:text-4xl font-extrabold mt-[50px]"><u>Come Try Our <br /> Newest Treat!</u></h4></button>
                        </div>
                    </div>
                </div>
                <div className="col-span-2">
                    <div className='border-dashed border-4 border-[#F4C790] md:px-5 lg:px-10 mx-[10px] md:mx-[50px]'>
                        <div className="flex flex-row justify-between px-5 md:px-0">
                            <div className="place-items-center px-5">
                                <img src={`${process.env.PUBLIC_URL}/media/images/Kopi Susu Keluarga.png`} className="w-[100px] md:w-[200px] lg:w-[120px] xl:w-[200px]" alt="FamilyMart Indonesia" />
                                <h3 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold text-center">Kopi Susu Keluarga</h3>
                            </div>
                            <div className="place-items-center px-5">
                                <img src={`${process.env.PUBLIC_URL}/media/images/Caramel Machiato.png`} className="w-[100px] md:w-[200px] lg:w-[120px] xl:w-[200px]" alt="FamilyMart Indonesia" />
                                <h3 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold text-center">Caramel Machiato</h3>
                            </div>
                        </div>
                        <div className="flex justify-center items-center px-5 md:px-0">
                            <div>
                                <h3 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold text-right">Crispy <br />Chicken Gulai</h3>
                            </div>
                            <div>
                                <img src={`${process.env.PUBLIC_URL}/media/images/Crispy Chicken Gulai.png`} className="w-[100px] md:w-[200px] md:w-[110px] lg:w-[120px] xl:w-[200px]" alt="FamilyMart Indonesia" />
                            </div>
                        </div>
                    </div>

                    <div className='flex md:hidden justify-end px-5'>
                        <button onClick={handleScroll}><h4 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold mt-[25px]"><u>Come Try Our Newest Treat!</u></h4></button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SectionMenu;
